import React, { type VFC } from 'react';

import { BlogPostsMacroHandler } from '@confluence/blog-posts-macro/entry-points/BlogPostsMacroRenderer.ts';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { RendererExtensionHandlers } from '@confluence/fabric-extension-lib/entry-points/extensionTypes.ts';

import { NestedAdfSSRRendererWrapperProvider } from './NestedAdfSSRRendererWrapperProvider.tsx';

type BlogPostsSSRExtensionHandlerProps = ExtensionHandlerProps & {
	appearance?: string;
	Renderer: VFC<any>;
	getExtensionHandlers: (options: any) => RendererExtensionHandlers;
};

export const BlogPostsSSRExtensionHandler: VFC<BlogPostsSSRExtensionHandlerProps> = ({
	contentId,
	extensionKey,
	mode,
	node,
	spaceKey,
	appearance,
	showTemplateVariablesInPreview,
	showTemplateInputInPreview,
	Renderer,
	getExtensionHandlers,
}) => (
	<NestedAdfSSRRendererWrapperProvider
		appearance={appearance}
		Renderer={Renderer}
		getExtensionHandlers={getExtensionHandlers}
		showTemplateInputInPreview={showTemplateInputInPreview}
		showTemplateVariablesInPreview={showTemplateVariablesInPreview}
	>
		{(RendererWrapper) => (
			<BlogPostsMacroHandler
				macroDefaultProps={{
					contentId,
					extensionKey,
					mode,
					node,
					spaceKey,
				}}
				macroParams={node?.parameters?.macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfSSRRendererWrapperProvider>
);
